import "./JobListBlock.css";

const HIRING_EMAIL = "careers@realanbatiment.com";

function JobList({ title, jobs }) {
  return (
    <section className="block joblist">

      <h2 className="joblist-title">{title || ''}</h2>

      <div className="joblist-grid">

        {(jobs || []).map((job, index) => (
          <div key={index} className="job-card">
            <h3>{job.title || ''}</h3>
            <span>{job.location || ''} • {job.type || ''}</span>

            <p>
              {job.description || ''}
            </p>

            <a
              href={`mailto:${HIRING_EMAIL}?subject=${encodeURIComponent(`Application for ${job.title || 'Open Position'}`)}`}
              className="apply-link"
            >
              Send Application
            </a>
          </div>
        ))}

      </div>

    </section>
  );
}

export default JobList;